import { EstadosOrdenTrabajoEnumChoice, useLoaders } from "@/shared"
import { useFetchOrdenTrabajos } from "@/shared/actions/erp"
import ImagesWithZoom from "@/shared/components/ui/Images/ImagesWithZoom"
import { Box, Chip, Grid, Stack, Typography } from "@mui/material"
import dayjs from "dayjs"
type ticketVisitaDetailProps = {
    ticketId: string
}

export default function TicketVisitaDetail({ ticketId }: ticketVisitaDetailProps) {
    //const isGlobalLoading = useUiStore(s=>s.isGlobalLoading)

    const {
        data: ordenTrabajo,
        isLoading: isLoadingTrabajo
    } = useFetchOrdenTrabajos({
        params: {
            id_ticket: ticketId,
            estado_orden_trabajo: EstadosOrdenTrabajoEnumChoice.REALIZADA
        }
    })
    console.log(ordenTrabajo)
    //const dataOnt = ordenTrabajo?.data?.data?.length

    const ot = ordenTrabajo?.data?.data?.[0]

    const estado_orden_trabajo = ot?.estado_orden_trabajo
    const estado_activacion = ot?.estado_activacion
    const flota_nombre = ot?.flota_data?.nombre || ot?.flota
    const fecha_inicio = ot?.fecha_hora_inicio_visita
    const fecha_fin = ot?.fecha_hora_fin_visita
    //const fotos_entrada = ot?.urls_fotos_entrada || []
    //const fotos_salida = ot?.urls_fotos_salida || []
    const requiereCambioOnt = ot?.requiere_cambio_ont
    const motivoCambioOnt = ot?.motivo_cambio_ont

    //console.log('ordenTrabajo', ordenTrabajo)
    function Detalle({ label, value }: { label: string; value?: string }) {
        return (
            <Grid item xs={6}>
                <Typography variant="caption" color="text.secondary">{label}</Typography>
                <Typography variant="body2">{value || '-'}</Typography>
            </Grid>
        )
    }
    /* const fotosEntrada = ot?.urls_fotos_entrada?.photosEntrada
        ? Object.values(ot.urls_fotos_entrada.photosEntrada)
            .filter((f: any) => f?.photoUrl)
            .map((f: any) => f.photoUrl)
        : [] */

    const fotosSalida = ot?.urls_fotos_salida?.photosVisita
        ? Object.values(ot.urls_fotos_salida.photosVisita).filter((f: any) => f?.photoUrl).map((f: any) => f.photoUrl) : []
    console.log('fotos salida', fotosSalida)
    useLoaders(isLoadingTrabajo)
    
    return (
        <>
            {/* <TimelineItem>
            <TimelineSeparator>
                <TimelineDot color="success" />
                <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{py:0, px:2, flex:1}}> */}
            {/* <Paper elevation={0} sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 2,  }}> */}

                {/* Header con chip de estado */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="subtitle2" fontWeight="bold">
                        DETALLES TÉCNICO
                    </Typography>
                    <Chip label={estado_orden_trabajo} size="small" color="success" />
                </Box>

                {/* Detalles en grid 2 columnas */}
                <Grid container spacing={1}>
                    <Detalle label="Iniciada Visita" value={
                        fecha_inicio
                            ? dayjs(fecha_inicio).format('DD/MM/YYYY HH:mm')
                            : '-'
                    } />
                    <Detalle
                        label="Finalizada Visita"
                        value={
                            fecha_fin
                                ? dayjs(fecha_fin).format('DD/MM/YYYY HH:mm')
                                : "-"
                        }
                    />

                    <Detalle label="Flota" value={flota_nombre} />
                    <Detalle label="Activación" value={estado_activacion} />

                    <Grid item xs={12}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                            <Typography variant="caption" color={"text.secondary"}>Cambio de ONT</Typography>
                            <Chip
                                label={requiereCambioOnt ? 'REQUERIDO' : 'No requerido'}
                                size="small"
                                color={requiereCambioOnt ? 'warning' : 'default'}
                                variant="outlined"
                            />

                        </Box>

                        {motivoCambioOnt && (
                            <Box>
                                <Typography variant="caption" color={"text.secondary"}>Motivo</Typography>
                                <Typography variant="body2" sx={{ mt: 0.5 }}>{motivoCambioOnt}</Typography>

                            </Box>
                        )}
                    </Grid>
                </Grid>
                <Typography variant="caption" color={"text.secondary"}>Fotos de salida</Typography>
                {/* Galería de fotos en fila */}
                <Stack direction="row" spacing={1} sx={{ mb: 2, overflowX: 'auto' }}>

                    {/* {fotosEntrada.map((url, i) => (
                            <ImagesWithZoom key={i} src={url} alt={`entrada-${i}`} />
                        ))} */}
                    {fotosSalida.map((url, i) => (
                        <ImagesWithZoom key={i} src={url} alt={`salida-${i}`} />
                    ))}
                </Stack>
            {/* </Paper> */}
         {/* </TimelineContent > */}
     {/*    </TimelineItem > */}
        </>
 
    )
}